import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Empregador, Secretaria } from '../../api.service';
import { RodapeCrudComponent } from '../../shared/rodape-crud.component';
import { ServicoMensagemAplicacao } from '../../shared/servico-mensagem-aplicacao';
import { ServicoPortariaFerias } from './servico-portaria-ferias';

@Component({
  selector: 'app-tela-cadastro-secretarias',
  standalone: true,
  imports: [CommonModule, FormsModule, RodapeCrudComponent],
  templateUrl: './tela-cadastro-secretarias.component.html'
})
export class TelaCadastroSecretariasComponent implements OnChanges {
  @Input() empregadores: Empregador[] = [];
  @Input() empregadorSelecionado = '';

  @Output() empregadorSelecionadoChange = new EventEmitter<string>();
  @Output() mensagem = new EventEmitter<string>();

  secretarias: Secretaria[] = [];
  secretariaSelecionada = '';
  secretaria: Secretaria = this.servico.novaSecretaria();

  constructor(
    private readonly servico: ServicoPortariaFerias,
    private readonly servicoMensagem: ServicoMensagemAplicacao
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['empregadorSelecionado']) {
      this.limpar();
      this.recarregar();
    }
  }

  selecionarEmpregador(empregadorId: string) {
    this.empregadorSelecionado = empregadorId;
    this.empregadorSelecionadoChange.emit(empregadorId);
    this.limpar();
    this.recarregar();
  }

  selecionarSecretaria(id: string) {
    this.secretariaSelecionada = id;
    const selecionada = this.secretarias.find(item => item.id === id);
    this.secretaria = selecionada
      ? { ...selecionada }
      : this.servico.novaSecretaria(this.empregadorSelecionado);
  }

  recarregar() {
    if (!this.empregadorSelecionado) {
      this.secretarias = [];
      return;
    }
    this.servico.listarSecretarias(this.empregadorSelecionado, true).subscribe({
      next: secretarias => this.secretarias = secretarias,
      error: erro => this.mensagem.emit(this.servicoMensagem.erroApi(erro, 'Nao foi possivel carregar as secretarias.'))
    });
  }

  limpar() {
    this.secretariaSelecionada = '';
    this.secretaria = this.servico.novaSecretaria(this.empregadorSelecionado);
  }

  salvar() {
    if (!this.empregadorSelecionado) {
      this.mensagem.emit('Selecione um empregador.');
      return;
    }
    if (!this.secretaria.nome?.trim()) {
      this.mensagem.emit('Informe o nome da secretaria.');
      return;
    }
    const editando = !!this.secretaria.id;
    this.servico.salvarSecretaria({
      ...this.secretaria,
      empregadorId: this.empregadorSelecionado,
      nome: this.secretaria.nome.trim()
    }).subscribe({
      next: salva => {
        this.secretaria = { ...salva };
        this.secretariaSelecionada = salva.id || '';
        this.mensagem.emit(this.servicoMensagem.registroSalvo(editando));
        this.recarregar();
      },
      error: erro => this.mensagem.emit(this.servicoMensagem.erroApi(erro, 'Nao foi possivel salvar a secretaria.'))
    });
  }

  excluir() {
    if (!this.secretaria.id || !window.confirm('Inativar esta secretaria?')) {
      return;
    }
    this.servico.excluirSecretaria(this.secretaria.id).subscribe({
      next: () => {
        this.mensagem.emit(this.servicoMensagem.registroExcluido());
        this.limpar();
        this.recarregar();
      },
      error: erro => this.mensagem.emit(this.servicoMensagem.erroApi(erro, 'Nao foi possivel inativar a secretaria.'))
    });
  }
}
